import React from 'react';
import Header from './Header';
import VideoSection from './VideoSection';
import AfterVideoSection from './AfterVideoSection';
import EventosCarousel from './EventosCarousel';
import Testimonios from './Testimonios';
import Footer from './Footer';
import ServiciosSection from './ServiciosSection';
import EquipoSection from './EquipoSection';

const HomePage = () => {
  return (
    <>
      <Header />
      <VideoSection />
      <AfterVideoSection />
      <EventosCarousel />
      <ServiciosSection />
      <EquipoSection />
      <Testimonios />
      <Footer />
    </>
  );
};

export default HomePage; 